import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface metadataState {
  data: any;
  loading: boolean;
}

const initialState: metadataState = {
  data: {},
  loading: false,
};

const metadataSlice = createSlice({
  name: "metadataSlice",
  initialState,
  reducers: {
    loadingMetadataList: (state) => {
      state.loading = true;
    },
    loadingSuccessMetadataList: (
      state,
      action: PayloadAction<{ [key: string]: any }>
    ) => {
      state.loading = false;
      state.data = action.payload;
    },
    loadingErrorMetadataList: (state) => {
      state.loading = false;
    },
  },
  extraReducers: () => {},
});

export const {
  loadingMetadataList,
  loadingSuccessMetadataList,
  loadingErrorMetadataList,
} = metadataSlice.actions;
export default metadataSlice.reducer;
